
ReportColumns = [{
    name: 'completion',
    label: 'Completion',
    percent: 'completion',
    num: 'successful',
    denom: 'exits',
    tooltip: [
        label: 'Completion',
        percent: 'completion',
        desc: 'completion.',
        values: [
            {name: 'exits', label: 'students exited.'}
            {name: 'successful', label: 'successful students'},
        ]
    ]
}, {
    name: 'litnum',
    label: 'Literacy / Numeracy',
    percent: 'litnum',
    num: 'litnum_gain',
    denom: 'litnum_eligible',
    tooltip: [{
        label: 'Literacy / Numeracy',
        percent: 'litnum',
        desc: 'with literacy or numeracy gain.'
        values: [
            {name: 'litnum_eligible',label: 'eligible students.'}
            {name: 'litnum_gain', label: 'students with gains.'}
        ]
    }, {
        label: 'Reading Grade',
        percent: 'reading',
        desc: 'with reading gain.'
        values: [
            {name: 'reading_eligible', label: 'eligible students.'}
            {name: 'reading_gain', label: 'with reading gains.'}
        ]
    }, {
        label: 'Math Grade',
        percent: 'math',
        desc: 'with math gain.'
        values: [
            {name: 'math_eligible', label: 'eligible students.'}
            {name: 'math_gain', label: 'with math gains.'}
        ]
    }]
}, {
    name: 'hse'
    label: 'HSE / Diploma',
    percent: 'credential',
    num: 'hse_earned',
    denom: 'hse_eligible',
    tooltip: [{
        label: 'HSE / Diploma',
        percent: 'credential',
        desc: 'earned credential.'
        values: [
            {name: 'hse_eligible', label: 'students without HSE at entry'}
            {name: 'hse_earned', label: 'students earned HSE.'}
        ]
    }]
}, {
    name: 'certification'
    label: 'Certification',
    percent: 'certification',
    num: 'certificate',
    denom: 'students',
    tooltip: [{
        label: 'Certification',
        percent: 'certification',
        desc: 'earned a certificate.'
        values: [
            {name: 'students', label: 'students enrolled.'}
            {name: 'certificate', label: 'students earned a certificate.'}
        ]
    }]
}, {
    name: 'placement'
    label: 'Placement',
    percent: 'placed',
    num: 'placed',
    denom: 'exits',
    tooltip: [{
        label: 'Placement',
        percent: 'placed',
        desc: 'placed',
        values: [
            {name: 'exits', label: 'students exited.'}
            {name: 'placed', label: 'students placed.'}
        ]
    }, {
        label: 'Job Placement',
        percent: 'placed_job',
        desc: 'placed in a job.'
        values: [
            {name: 'exits', label: 'students exited.'}
            {name: 'placed_job', label: 'students placed in job.'}
        ]
    }, {
        label: 'Education Placement',
        percent: 'placed_edu',
        desc: 'placed in education.'
        values: [
            {name: 'exits', label: 'students exited.'}
            {name: 'placed_edu', label: 'students placed in education'}
        ]
    }]
}]


outcomeComparisonStates = ($stateProvider, TagUrl) ->
    'ngInject'

    url = new TagUrl()
        .addTagTypes(['program', 'location', 'participant'])
        .setTagDefault('affiliation', 'all')
        .addExtraParam('page', {type: 'int', value: 1, squash: true})
        .addExtraParam('show-empty', {value: 'no', squash: true})
        .addExtraParam('sort', 'name')

    programUrl = new TagUrl()
        .addTagTypes(['participant'])
        .addExtraParam('page', {type: 'int', value: 1, squash: true})
        .addExtraParam('show-empty', {value: 'no', squash: true})
        .addExtraParam('sort', 'name')

    $stateProvider.state 'reports.comparison',
        abstract: true
        url: url.buildUrl()
        params: url.params,
        data: tagUrl: url
        reloadOnSearch: false,
        templateUrl: 'reports/outcomeComparison/base'
        controller: 'OutcomeComparisonBaseReportController'
        controllerAs: '$ctrl'
        resolve:
            program: () -> null
            config: resolveComparisonConfig

    $stateProvider.state 'reports.comparison.value',
        url: '/:outcome-comparison'
        reloadOnSearch: false,
        templateUrl: 'reports/outcomeComparison/table'
        controller: 'OutcomeComparisonReportController'
        controllerAs: '$ctrl'
        resolve:
            config: resolveSingleConfig

    $stateProvider.state 'program.reports.comparison',
        url: programUrl.buildUrl('')
        params: programUrl.params
        data: tagUrl: programUrl
        reloadOnSearch: false,
        templateUrl: 'reports/outcomeComparison/base'
        controller: 'OutcomeComparisonBaseReportController'
        controllerAs: '$ctrl'
        resolve:
            config: resolveComparisonConfig

     $stateProvider.state 'program.reports.comparison.value',
        url: '/:outcome-comparison'
        reloadOnSearch: false,
        templateUrl: 'reports/outcomeComparison/table'
        controller: 'OutcomeComparisonReportController'
        controllerAs: '$ctrl'
        resolve:
            config: resolveSingleConfig

resolveComparisonConfig = ($http, ApiUrl, program) ->
    'ngInject'

    baseUrl = ApiUrl.partial('reports', 'comparison', 'config')
    url = if program then baseUrl(program.id) else baseUrl()
    return $http.get(url).then (result) ->
        items = result.data.items
        items[i.name] = i for i in items
        return items


resolveSingleConfig = ($stateParams, config) ->
    'ngInject'
    return config[$stateParams.outcome];


class OutcomeComparisonBaseReportController

    ### @ngInject ###
    constructor: ($scope, config, program, TagRefreshService, $timeout) ->
        @config = config
        @program = program
        @refresh = TagRefreshService.bindTagRefreshToScope($scope)

        $timeout () =>
            TagRefreshService.bindAddRemoveEvents($scope, @tagFilterController)

class OutcomeComparisonReportController

    ### @ngInject ###
    constructor: ($stateParams, $state, $http, ApiUrl, $timeout, $scope, config, program) ->
        @state = $state
        @http = $http
        @scope = $scope

        @config = config
        @columns = ReportColumns
        @program = program

        baseUrl = ApiUrl.partial('reports', 'comparison', $stateParams.outcome)
        @url = if program then baseUrl(program.id) else baseUrl()

        @sort = $stateParams.sort or 'name'
        @showEmpties = $stateParams['show-empty'] == 'yes'
        @loading = true

        $scope.$on 'tagRefresh', @onTagChange

        @triggerLoad = () =>
            $timeout.cancel(@timeoutPromise)
            @timeoutPromise = $timeout @loadData, 100

        $scope.triggerRefresh()

    loadData: () =>
        @loading = true
        params = angular.extend {}, @tags,
            sort: @sort
            'show-empty': if @showEmpties then 'yes' else 'no'
        @state.go '.', params, location: 'replace'
        @http.get(@url, params: params).then (result) =>
            @loading = false
            @maximums = result.data.maximums
            @data = result.data.items
            @data.unshift result.data.totals

    onTagChange: (event, tags) =>
        if angular.equals(tags, @tags) then return
        @tags = tags
        @triggerLoad()

    onSortChange: () ->
        @triggerLoad()

    toggleTag: (tag) ->
        event = if tag.selected then 'removeTag' else 'addTag'
        @scope.$emit event, tag

    toggleEmpties: () ->
        @showEmpties = !@showEmpties
        @triggerLoad()


module.config outcomeComparisonStates
module.controller 'OutcomeComparisonReportController', OutcomeComparisonReportController
module.controller 'OutcomeComparisonBaseReportController', OutcomeComparisonBaseReportController
